import {
   Cardinality,
   RelationOverviewDetails,
   RelatedSalesTemplateOverviewDetails
} from '@flowwai-frontend/bps-officer-web/graphql'
import {
   PipelineItemTypeEnum,
   RelatedRecordTemplateConfig,
   RelationCardinalityTypeEnum,
   RelationData
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

import { convertPipeLineTypeToPipeLineTypeEnum } from './pipeline'

export const convertCardinalityToRelationCardinalityTypeEnum = (
   cardinality: Cardinality,
   shouldReverseCardinality?: boolean
): RelationCardinalityTypeEnum => {
   switch (cardinality) {
      case Cardinality.OneToOne:
         return RelationCardinalityTypeEnum.ONE_TO_ONE
      case Cardinality.ManyToMany:
         return RelationCardinalityTypeEnum.MANY_TO_MANY
      case Cardinality.OneToMany:
         return shouldReverseCardinality
            ? RelationCardinalityTypeEnum.MANY_TO_ONE
            : RelationCardinalityTypeEnum.ONE_TO_MANY
   }
}

export const transformRelatedSalesTemplateOverviewDetails = (
   config: RelatedSalesTemplateOverviewDetails
): RelatedRecordTemplateConfig => ({
   salesTemplateId: config.salesTemplateId,
   pipelineItemType: config.pipelineItemType
      ? convertPipeLineTypeToPipeLineTypeEnum(config.pipelineItemType)
      : PipelineItemTypeEnum.lead, //TODO:RelationField: Remove this optional pipelineItemType when updated from backend
   salesTemplateName: config.salesTemplateName
})

export const convertRelationOverviewDetailsToRelationData = (
   relation: RelationOverviewDetails
): RelationData => ({
   cardinality: convertCardinalityToRelationCardinalityTypeEnum(
      relation.cardinality
   ),
   name: relation.name,
   relationId: relation.relationId,
   fromSalesTemplateConfig: transformRelatedSalesTemplateOverviewDetails(
      relation.fromSalesTemplateConfig
   ),
   toSalesTemplateConfig: transformRelatedSalesTemplateOverviewDetails(
      relation.toSalesTemplateConfig
   )
})
